import './detail/account.html';
import './detail/transactions/tab.html';
import './detail/statements/tab.html';
import './detail/intradays/tab.html';
import { accounts, balanceHistory, accountsDetails } from '../../services/arsweb/RoutingPaths';
import { FlotService } from '../../services/FlotService';
import { ChartUtil } from '../../utils/chart/ChartUtil';
import { DetailViewController } from '../../controller/DetailViewController';
import { CONSOLIDATION_CURRENCY_PARAMS } from '../../controller/CommonViewController';
import { CONSOLIDATION_CURRENCY } from '../../components/tables/accounts/accountsView.directive';
import { keyLanguage } from 'fides-angularjs-components/src/fts-services/fts-user-service';

import moment from 'moment';
import { DEF_CURRENCY } from "../dashboard/dashboard";
import { REACT_AH_CRUMBS_DETAIL_DATA_READY } from "../../components/react/AwApplicationHeaderHelpers/AwApplicationHeaderHelpers";

export const DETAIL_BALANCE_DAYS = 'detail.balanceDays';
export const DETAIL_ACCOUNTROUTE = 'app.accountDetail';
export const DETAIL_ACCOUNT_INTRADAYROUTE = 'app.accountDetailintradays';
export const DETAIL_ACCOUNT_STATEMENTROUTE = 'app.accountDetailstatements';
export const USERREPORT_ACCOUNTROUTE = "app.accountsUserReport";

export const TAB_TRANSACTIONS = 'transactions';
export const TAB_STATEMENTS = 'statements';
export const TAB_INTRADAYS = 'intradays';

export class AccountController extends DetailViewController {
    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies);
        this.accountID = arsMainDependencies.$stateParams.id;
        this.DEFAULT_DAYS = 10;
        this.filterFormatter = userService.filterFormatter;
        this.store = arsMainDependencies.store;
        this.$scope.flotService = new FlotService(arsMainDependencies.document, userService, this.state);
        this.$scope.pickedDate = new Date();
        this.initDateRange();
        // available tabs
        $scope.tabs = [
            { id: TAB_TRANSACTIONS, label: 'TRANSACTIONS', state: DETAIL_ACCOUNTROUTE },
            { id: TAB_STATEMENTS, label: 'STATEMENTS', state: DETAIL_ACCOUNT_STATEMENTROUTE },
            { id: TAB_INTRADAYS, label: 'INTRADAYS', state: DETAIL_ACCOUNT_INTRADAYROUTE }
        ];
        this.isIntraday = this.state.current.name === DETAIL_ACCOUNT_INTRADAYROUTE;
        this.unReadLabel = this.isIntraday ? 'UNREAD_INTRADAYS' : 'UNREAD_STATEMENTS';
    }

    initSessionPersistanceDependencies() {
        //init consolidation currency
        this.$scope.consolitationcurrency = this.sessionPersistance.get(CONSOLIDATION_CURRENCY) || DEF_CURRENCY;
        this.sessionPersistance.set(CONSOLIDATION_CURRENCY, this.$scope.consolitationcurrency);

        this.$scope.accountInfo = {};
        this.days = ChartUtil.getBalanceHistChartDays(this.translate);

        this.initChartOptions();

        if (this.accountID) {
            this.$scope.detailPromise = this.loadAccount();
        }
    }

    loadBalanceHistData(day) {
        this.selDay = day;
        this.sessionPersistance.set(DETAIL_BALANCE_DAYS, this.selDay);
        this.noData = false;

        this.balanceDataset = [];
        this.lineChartDataSet = [];
        const locale = this.store.get(keyLanguage);
        this.balanceHistoryMonths = ChartUtil.getBalanceMonthTitle(moment(this.selDay), locale);
        this.accountService.service.config.params['days'] = this.selDay;
        this.accountService.getUserData(accounts + balanceHistory).then((data) => {
            if (data.length > 0) {
                ChartUtil.formatAxisDisplay(this.selDay, this.barChartOptions, [1, "day"], '%d', locale);
                ChartUtil.formatAxisDisplay(this.selDay, this.lineChartOptions, [1, "day"], '%d', locale);

                // barchart data
                const posdata = [];
                const negdata = [];

                //linechart data
                const accCurrData = [];
                const consolidCurrData = [];

                data.forEach(it => {
                    const elementDate = new Date(it.date);
                    accCurrData.push([elementDate, it.closingBalance, this.$scope.accountInfo.balance.fractionDigits]);
                    consolidCurrData.push(
                      [elementDate, it.consolidatedClosingBalance, this.$scope.accountInfo.consolidatedBalance.fractionDigits]);

                    if (it.closingBalance >= 0) {
                        posdata.push([elementDate, it.closingBalance]);
                    } else {
                        negdata.push([elementDate, it.closingBalance]);
                    }
                });

                this.balanceDataset = [
                    {
                        data: posdata,
                        fractionDigits: this.$scope.accountInfo.balance.fractionDigits
                    },
                    {
                        data: negdata,
                        fractionDigits: this.$scope.accountInfo.balance.fractionDigits
                    }
                ];
                this.lineChartDataSet = [
                    {
                        label: this.$scope.accountInfo.currencyCode, data: accCurrData,
                        fractionDigits: this.$scope.accountInfo.balance.fractionDigits
                    },
                    {
                        label: this.$scope.consolitationcurrency.code, data: consolidCurrData,
                        fractionDigits: this.$scope.accountInfo.consolidatedBalance.fractionDigits
                    }
                ];
            } else {
                this.noData = true;
            }
        });
    }

    initChartOptions() {
        this.barChartOptions = ChartUtil.getBarChartDetailOptions('black');
        this.lineChartOptions = ChartUtil.getLineChartDetailOptions('black');
    }

    accountDetails(accData) {
        if (accData && !_.isEmpty(accData)) {
            const nillValuesFiltered = _.omitBy(accData, _.isNil);
            this.$scope.accountInfo = nillValuesFiltered[Object.keys(nillValuesFiltered)[0]];
            this.fractionDigits = this.$scope.accountInfo.balance.fractionDigits;
            this.loadBalanceHistData(this.graphsRadioSelection());
            this.$scope.$emit(REACT_AH_CRUMBS_DETAIL_DATA_READY, this.$scope.accountInfo);
        }
    }

    graphsRadioSelection() {
        const indexDays = 0;
        let days = this.sessionPersistance.get(DETAIL_BALANCE_DAYS) || this.days[indexDays].value;
        const daysRange = moment(this.$scope.pickedDate.valueOf()).diff(moment(this.minDate.valueOf()), 'days');
        this.days.forEach(d => d.disabled = false);
        const lowerLimit = 19;
        // limit graphs on range span that can't be ploted
        if (daysRange <= lowerLimit + 60) {
            this.days[indexDays + 2].disabled = true; // disable 3 months
            if (daysRange <= lowerLimit) {
                this.days[indexDays + 1].disabled = true; // disable  month
            }
            days = daysRange <= lowerLimit ? this.days[indexDays].value : this.days[indexDays + 1].value; // 10 days || 1 month
        }
        return days;
    }

    loadAccount() {
        this.accountService.service.config.params['id'] = this.accountID;
        this.accountService.service.config.params['endDate'] = this.$scope.pickedDate.valueOf();
        this.accountService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.$scope.consolitationcurrency.code;
        return this.accountService.getUserData(accountsDetails).then(data => this.accountDetails([data]));
    }
}
